import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';
import { assertCanManageUsers, setUserManagementGrant } from '../server/access.js';

/** Revoking your own rights is refused — it would lock the last admin out of this screen. */
export const setUserManagementGrantForUser = registerMutation({
  type: () => Boolean,
  operationName: 'setUserManagementGrantForUser',
  resolve: (userID: string, allowed: boolean) => {
    return async () => {
      const callerID = await assertCanManageUsers();
      if (userID === callerID && !allowed)
        throw new ExpectedError('Du kannst dir die Benutzerverwaltung nicht selbst entziehen.');

      await setUserManagementGrant(userID, allowed);
      return allowed;
    };
  },
  params: [
    { name: 'userID', type: () => String },
    { name: 'allowed', type: () => Boolean },
  ],
});
